import { Disclosure } from "@headlessui/react";
import ChevronRight from "@material-ui/icons/ChevronRight";
import type { DigitalAsset } from "../types";

interface SocialNetworkSectionProps {
  asset: DigitalAsset;
  canViewTwitter: boolean;
  canViewLinkedIn: boolean;
  canViewYouTube: boolean;
  canViewInstagram: boolean;
}

const SocialNetworkSection = ({
  asset,
  canViewTwitter,
  canViewLinkedIn,
  canViewYouTube,
  canViewInstagram,
}: SocialNetworkSectionProps) => {
  if (
    !canViewTwitter &&
    !canViewLinkedIn &&
    !canViewYouTube &&
    !canViewInstagram
  ) {
    return null;
  }

  return (
    <Disclosure defaultOpen>
      {({ open }) => (
        <div className="bg-white rounded-lg box-shadow">
          <Disclosure.Button className="disclosureBtn ml-2">
            <ChevronRight
              className={`${
                open ? "transform rotate-90" : " text-gray-500"
              } text-gray-500 w-5 h-5 `}
            />
            <span className="disclosureLabel ml-2">Social Network URLs</span>
          </Disclosure.Button>

          <Disclosure.Panel className="text-xs">
            <div className="grid grid-cols-2">
              {canViewTwitter && (
                <div className="grid grid-cols-1 py-2 px-4 space-y-2">
                  <label className="mx-4 expandedLabel fontExpand">
                    Twitter URL:
                  </label>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mx-4 expandedData fontExpand text-blue-500 underline break-all self-center"
                    href={
                      asset.twitterUrl && asset.twitterUrl !== "NULL"
                        ? asset.twitterUrl
                        : ""
                    }
                  >
                    {asset.twitterUrl && asset.twitterUrl !== "NULL"
                      ? asset.twitterUrl
                      : ""}
                  </a>

                  {canViewYouTube && canViewInstagram && (
                    <div className="border-b border-gray-200"></div>
                  )}
                </div>
              )}

              {canViewLinkedIn && (
                <div className="grid grid-cols-1 py-2 px-4 space-y-2">
                  <label className="mx-4 expandedLabel fontExpand">
                    LinkedIn URL:
                  </label>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mx-4 expandedData fontExpand text-blue-500 underline break-all self-center"
                    href={
                      asset.linkedInUrl && asset.linkedInUrl !== "NULL"
                        ? asset.linkedInUrl
                        : ""
                    }
                  >
                    {asset.linkedInUrl && asset.linkedInUrl !== "NULL"
                      ? asset.linkedInUrl
                      : ""}
                  </a>

                  {canViewYouTube && canViewInstagram && (
                    <div className="border-b border-gray-200"></div>
                  )}
                </div>
              )}

              {canViewYouTube && (
                <div className="grid grid-cols-1 py-2 px-4 space-y-2">
                  <label className="mx-4 expandedLabel fontExpand">
                    YouTube URL:
                  </label>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mx-4 expandedData fontExpand text-blue-500 underline break-all self-center"
                    href={
                      asset.youtubeUrl && asset.youtubeUrl !== "NULL"
                        ? asset.youtubeUrl
                        : ""
                    }
                  >
                    {asset.youtubeUrl && asset.youtubeUrl !== "NULL"
                      ? asset.youtubeUrl
                      : ""}
                  </a>
                </div>
              )}

              {canViewInstagram && (
                <div className="grid grid-cols-1 py-2 px-4 space-y-2">
                  <label className="mx-4 expandedLabel fontExpand">
                    Instagram URL:
                  </label>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mx-4 expandedData fontExpand text-blue-500 underline break-all self-center"
                    href={
                      asset.instagramUrl && asset.instagramUrl !== "NULL"
                        ? asset.instagramUrl
                        : ""
                    }
                  >
                    {asset.instagramUrl && asset.instagramUrl !== "NULL"
                      ? asset.instagramUrl
                      : ""}
                  </a>
                </div>
              )}
            </div>
          </Disclosure.Panel>
        </div>
      )}
    </Disclosure>
  );
};

export default SocialNetworkSection;